import { Message } from '../../models/message';

export class UpdateMessage {
    public static readonly type = '[MessagingState] Update message';

    constructor(public message: Message) {}
}
